import React from 'react';
import ReactDOM from 'react-dom';
import './styles/bootstrap.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {IntlProvider} from 'react-intl';
import {  BrowserRouter as Router} from 'react-router-dom';
import RelayEnvironment from "./utils/RelayEnvironment";
const {RelayEnvironmentProvider} = require('react-relay');
ReactDOM.render(
  <React.StrictMode>
      <RelayEnvironmentProvider environment={RelayEnvironment}>
          <IntlProvider locale={"en"}>
              <Router>
                <App />
              </Router>
          </IntlProvider>
      </RelayEnvironmentProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
